<template>
  <div>
    <BulmaAccordion class="is-hidden-tablet"
            :dropdown="false"
            :icon="'caret'"
            :caretAnimation="{
              duration: '.2s',
              timerFunc: 'ease-in-out',
            }"
            :slide="{
              duration: '.2s',
              timerFunc: 'ease',
            }"
    >
      <BulmaAccordionItem>
        <h4 slot="title" class="has-text-weight-bold">Reviewers</h4>
        <p v-if="!isLoggedIn" slot="content">
          <router-link to="/login">Sign in</router-link><br/>
          <router-link to="/register">Register</router-link><br/>
          <a :href="blog_url" rel="nofollow">Blog</a>
        </p>
        <p v-if="isLoggedIn" slot="content">
          <a :href="blog_url" rel="nofollow">Blog</a>
        </p>
      </BulmaAccordionItem>
      <BulmaAccordionItem>
        <h4 slot="title" class="has-text-weight-bold">Businesses</h4>
        <p slot="content">
          <a :href="portal_url" rel="nofollow">Hellopeter Business</a><br/>
          <a :href="`${portal_url}/plans`" rel="nofollow">Plans&nbsp;&amp;&nbsp;Pricing</a><br/>
          <a href="https://business.hellopeter.com/login" rel="nofollow">Business sign in</a>
        </p>
      </BulmaAccordionItem>
      <BulmaAccordionItem>
        <h4 slot="title" class="has-text-weight-bold">Support</h4>
        <p slot="content">
          <a :href="blog_url">Resources</a><br/>
          <a :href="`${blog_url}/faqs`">FAQ's</a><br/>
          <router-link to="/contact-us">Contact us</router-link>
        </p>
      </BulmaAccordionItem>
    </BulmaAccordion>
    <footer class="footer is-hidden-tablet">
      <div class="columns is-mobile">
        <div class="column">
          <a class="social-icon" :href="facebook" target="_blank" rel="nofollow"><i class="fab fa-facebook-f"></i></a>
        </div>
        <div class="column">
          <a class="social-icon" :href="instagram" target="_blank" rel="nofollow"><i class="fab fa-instagram"></i></a>
        </div>
        <div class="column">
          <a class="social-icon" :href="twitter" target="_blank" rel="nofollow"><i class="fab fa-twitter"></i></a>
        </div>
        <div class="column">
          <a class="social-icon" :href="linkedin" target="_blank" rel="nofollow"><i class="fab fa-linkedin-in"></i></a>
        </div>
      </div>
    </footer>
    <footer class="footer is-hidden-mobile">
      <div class="columns">
        <div class="column is-2-tablet">
          <h4 class="title has-text-weight-bold">Reviewers</h4>
          <p v-if="!isLoggedIn" class="has-text-left">
            <router-link to="/login">Sign in</router-link><br/>
            <router-link to="/register">Register</router-link><br/>
            <a :href="blog_url" rel="nofollow">Blog</a>
          </p>
          <p v-if="isLoggedIn" class="has-text-left">
            <a :href="blog_url" rel="nofollow">Blog</a>
          </p>
        </div>
        <div class="column is-3-tablet">
          <h4 class="title has-text-weight-bold">Businesses</h4>
          <p class="has-text-left">
            <a :href="portal_url" rel="nofollow">Hellopeter Business</a><br/>
            <a :href="`${portal_url}/plans`" rel="nofollow">Plans&nbsp;&amp;&nbsp;Pricing</a><br/>
            <a href="https://business.hellopeter.com/login" rel="nofollow">Business sign in</a>
          </p>
        </div>
        <div class="column is-2-tablet">
          <h4 class="title has-text-weight-bold">Support</h4>
          <p class="has-text-left">
            <a :href="blog_url">Resources</a><br/>
            <a :href="`${blog_url}/faqs`">FAQ's</a><br/>
            <router-link to="/contact-us">Contact us</router-link>
          </p>
        </div>
        <div class="column is-right">
          <h4 class="title has-text-weight-bold">Connect with us</h4>
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <a class="social-icon" :href="facebook" target="_blank" rel="nofollow"><i class="fab fa-facebook-f"></i></a>
            </div>
            <div class="column is-narrow">
              <a class="social-icon" :href="instagram" target="_blank" rel="nofollow"><i class="fab fa-instagram"></i></a>
            </div>
            <div class="column is-narrow">
              <a class="social-icon" :href="twitter" target="_blank" rel="nofollow"><i class="fab fa-twitter"></i></a>
            </div>
            <div class="column is-narrow">
              <a class="social-icon" :href="linkedin" target="_blank" rel="nofollow"><i class="fab fa-linkedin-in"></i></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <section class="section">
      <p class="has-text-left">&copy; Copyright 2018 hellopeter.com and its affiliates. All rights reserved. | <router-link to="/legal/legal">Legal</router-link></p>
    </section>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import auth from '@/mixins/auth.js'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'

  export default {
    name: 'DefaultFooter',
    components: {
      BulmaAccordion,
      BulmaAccordionItem
    },
    mixins: [auth],
    data () {
      return {
        blog_url: process.env.BLOG_URL,
        portal_url: process.env.PORTAL_URL,
        facebook: 'https://www.facebook.com/hellopetercom',
        twitter: 'https://twitter.com/hellopetercom',
        instagram: 'https://www.instagram.com/hellopeter_za',
        linkedin: 'https://www.linkedin.com/company/hellopeter'
      }
    }
  }
</script>
<style>
  .accordion-body > .card-content, .accordion-body > .card-content a {
    color: #58595B;
    background-color: #F5F5F5;
  }

  .accordion-body > .card-content {
    padding: 0.8rem 0.75rem;
  }

  .accordion-body > .card-content > p {
    line-height: 1.9rem;
  }

  .accordion {
    font-size: 0.9rem;
  }

  .accordion > .card > .card-header > .card-header-title {
    color: #58595B;
  }

  .accordion > .card > .card-header > .card-header-icon > .icon > svg > path {
    fill: #58595B;
  }
  .accordion > .card > .card-header > .card-header-icon{
    width: 36px !important;
    margin-right: 10px !important;
  }

  .footer {
    background-color: #ffffff;
    padding: 1.5rem;
  }

  .social-icon {
    color: #ffffff;
    background-color: #30AAE1;
    display: block;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    font-size: 1.5rem;
    line-height: 45px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .footer + .section {
    color: #ffffff;
    background-color: #30AAE1;
    font-size: 0.9rem;
    padding: 0;
    height: 74px;
  }

  .footer + .section > p {
    width: 100%;
    max-width: 1125px;
    height: 74px;
    line-height: 74px;
    margin: 0 auto;
  }

  .footer + .section > p > a, .footer + .section > p > a:hover, .footer + .section > p > a:visited {
    text-decoration: none;
    color: #ffffff;
  }

  .footer.is-hidden-mobile {
    font-size: 1rem;
    padding-top: 3rem;
    padding-bottom: 3rem;
    border-top: 1px solid #C9C9C9;
  }

  .footer.is-hidden-mobile .title {
    font-size: 1.1rem;
    color: #58595B;
    margin-bottom: 1rem!important;
  }

  .footer.is-hidden-mobile a {
    font-size: 1rem;
    color: #58595B;
  }

  .footer.is-hidden-mobile p {
    line-height: 2rem;
  }

  .footer.is-hidden-mobile > .columns {
    max-width: 1125px;
    margin-left: auto;
    margin-right: auto;
  }

  .footer.is-hidden-mobile > .columns > .column:first-child {
    padding-left: 0;
  }

  .footer.is-hidden-mobile > .columns > .column.is-right .social-icon {
    color: #ffffff;
    font-size: 1.4rem;
  }

  @media screen and (max-width: 1124px) {
    .footer + .section > p {
      padding-left: 1.5rem;
    }
  }

  @media screen and (max-width: 767px) {
    .footer + .section > p {
      padding-left: 1rem;
      padding-right: 1rem;
      line-height: 25px;
      padding-top: 0.75rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/layouts/DefaultFooter.vue